<template>
  <!--  隐私政策-->
  <div class='wrapper'>
    <h1 class='main-title'>山东一卡通APP隐私政策</h1>
    <dl>
        <dt>本政策仅适用于山东一卡通APP相关产品和服务</dt>
        <dt>本版本更新发布及生效日期：2026年10月13日</dt>
        <dt>本政策将帮助您了解以下内容：</dt>
        <dd>一、我们如何收集您的信息</dd>
        <dd>二、我们如何使用Cookie等技术</dd>
        <dd>三、我们如何存储和保护个人信息</dd>
        <dd>四、我们如何使用个人信息</dd>
        <dd>五、我们如何对外提供个人信息</dd>
        <dd>六、您的权利</dd>
        <dd>七、您如何管理您的个人信息</dd>
        <dd>八、对第三方责任的声明</dd>
        <dd>九、未成年人隐私权特别约定</dd>
        <dd>十、本政策的适用及更新</dd>
        <dd>十一、其他事项</dd>
        <dd>十二、与我们联系</dd>
      </dl>
      <p>
        易通金服支付有限公司（注册地址：山东省济南市高新区新泺大街888号；以下或称“我们”）尊重并保护您的隐私，我们深知个人信息对您的重要性，会尽力保护您的个人信息安全。我们致力于维护您对我们的信任，恪守以下原则保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、必要性原则、确保安全原则、公开透明原则等。同时，我们承诺依法采取相应的安全保护措施来保护您的个人信息。</p>
      <p>
        您使用我们山东一卡通APP（以下简称山东一卡通）相关产品和服务时，我们将按照山东一卡通APP隐私政策（以下简称“本政策”）收集、存储、使用及对外提供您的个人信息。同时，我们会通过本政策向您说明，我们如何为您提供访问、更新、管理和保护您的信息的服务。我们努力用通俗易懂、简明扼要的文字表达，并对本政策中与您的权益存在重大关系的条款，采用粗体字进行标注以提示您注意。
        本政策与您使用我们的服务关系紧密，请您在使用山东一卡通APP相关产品和服务前，仔细阅读并理解《山东一卡通APP隐私政策》全部内容，做出您认为适当的选择。</p>
      <p>
        为了遵守国家法律法规及监管规定（例如：进行实名制管理、履行反洗钱职责、采取风险防范措施），也为了向您提供服务及提升服务质量（例如：支持我们开发新产品或完善已有产品功能，为您提供和推荐更为优质或适合的服务），我们需要收集、存储、使用及对外提供您的信息，同时更好地保护您的账户及资金安全。</p>
      <p>本政策适用于在中华人民共和国境内（港、澳、台地区除外）收集、使用、存储及对外提供您的个人信息的行为。</p>
      <p>如您对本政策内容有任何疑问、意见或建议，您可通过拨打客服电话400-618-6900与我们取得联系</p>
    <h1>一、我们如何收集个人信息</h1>
    <p>在您使用山东一卡通APP及相关服务时，在以下情形中我们需要收集您的一些信息，用以向您提供服务、提升我们的服务质量、保障您的账户和资金安全以及符合国家法律法规及监管规定：</p>
    <div>1、依据法律法规及监管规定履行反洗钱义务及进行实名制管理</div>
    <ul>
      <li>（1）在您注册山东一卡通账户时，您需要提供<b>手机号码及验证码</b>，使用山东一卡通服务时，您需要提供<b>手机号码</b>作为账号登录名，登录时，我们还需手机您的<b>硬件序列号、唯一设备识别码</b>以验证账号及密码完成登录。
      </li>
      <li>（2）为履行法律强制性义务和监管要求（包括反洗钱义务和实名制管理要求），在您开户使用<b>刷卡收款</b>服务时，您需要完成实名认证过程：为完成实名认证过程，您需要提供您的<b>姓名、有效身份证件号码、银行卡号、银行预留手机号码、动态验证码以完成验证；</b>在使用<b>机构管理</b>进行商户入网时，您需要提供<b>商户法人姓名、商户法人身份证号、商户登记法人手机号码及动态验证码、商户开户行账号、商户预留手机号等信息；</b>我们会将前述信息与发卡银行进行验证，同时，为了验证您提供信息的准确性和完整性，我们会与合法留存您的信息的国家机关、金融机构、企事业单位进行核对；如在验证核对过程中我们需要向前述验证机构收集您的信息，我们会依照法律法规的规定要求相关验证机构说明其个人信息来源，并对其个人信息来源的合法性进行确认。如您不提供前述信息，可能无法使用相应服务。
      </li>
      <li>
        （3）我们需根据《支付机构反洗钱和反恐怖融资管理办法》等反洗钱相关法律法规及监管要求，提示您适时提供<b>有效身份证件的彩色影印件或照片</b>以供我们核对并留存；如您不提供前述彩色影印件或照片，可能无法使用部分服务。
      </li>
    </ul>
    <div>2、入账卡</div>
    <ul>
      <li>您使用<b>刷卡收款</b>时，需要提供用于结算的<b>银行卡号、银行留存手机号、动态验证码，</b>以完成结算卡的添加和更换，如您不提供前述信息，可能无法使用相应服务。
      </li>
    </ul>
    <div>3、商户绑定</div>
    <ul>
      <li>在您使用山东一卡通绑定您已有的商户或商户新入网时时，您需要提供商户登记法人手机号码的<b>动态验证码</b>或<b>商户的证件号码、商户名称、商户法人姓名、商户法人身份证号、商户法人银行卡、商户开户行账号、商户预留手机号</b>用于我们信息安全验证。如您不提供前述信息，可能无法完成相关操作。
      </li>
    </ul>
    <div>4、风险防范</div>
    <ul>
      <li>（1）为了保障您的账户和资金安全，在您需找回密码时，我们需要验证<b>手机号码及动态验证码。</b></li>
      <li>（2）为了提高您使用我们服务的安全性，防止您的资金、个人信息被不法分子获取，我们需要记录您使用的服务类别、方式及相关操作信息，例如：<b>设备型号、IP地址、设备IMEI编号、设备软件版本信息、设备识别码、设备标识符、所在位置、网络使用习惯</b>以及其他与服务相关的日志信息。如您不同意提供前述信息，可能无法完成风控验证。
      </li>
      <li>（3）为了保障软件与服务的安全运行，经您授权后，我们会收集您的操作系统版本号、国际移动设备识别码、OAID、ICCID、唯一设备标识符(IMEI/Android
        ID/IDFA/IDFV/OpenUDID/GUID/GAID)、获取SIM卡信息IMSI信息、获取硬件序列号、网络设备硬件地址（MAC地址）、基本服务集标识符（SSID、BSSID）、当前Wi-Fi连接信息（读取WIFI扫描结果）、IP
        地址、WLAN接入点、蓝牙、基站、软件版本号、网络接入方式、类型、状态、网络质量数据、操作、使用、服务日志、地理位置（经度、纬度）、传感器。为了收集上述基本的个人设备信息，我们将会申请访问您的设备信息的权限，我们收集这些信息是为了向您提供我们基本服务和基础功能。
      </li>
    </ul>
    <div>5、关于不提供个人金融信息的说明</div>
    <ul>
      <li>（1）<b>基础服务不受影响</b>。您有权拒绝提供个人金融信息（如银行卡号、银行留存手机号、支付账户等），且不影响您继续使用本应用的核心功能。</li>
      <li>（2）<b>部分功能可能受限</b>。若您选择不提供必要金融信息，与此相关的核心服务（例如支付购买预付卡、商城购物等）可能无法正常启用。</li>
      <li>（3）<b>合规风险提示</b>。根据相关法律法规要求，在涉及反洗钱、交易安全验证等场景时，若您拒绝提供必需信息，我们可能无法继续提供对应服务。</li>
      <li>（4）<b>用户权益保障</b>。您的拒绝不会导致服务质量降级或账户权益受损，我们承诺始终通过显著方式提前告知每项信息收集的具体用途。</li>
    </ul>
      <div>6、以下情形中，您可选择是否授权我司收集、使用您的个人信息：</div>
      <ul>
        <li>（1）设备状态，用于确定设备识别码，以保证账号登录的安全性。拒绝授权后，消息推送部分功能将无法正常使用。</li>
        <li>
          （2）存储权限，用于缓存您在使用山东一卡通APP过程中产生的文本、图像。拒绝授权后，更换头像、版本更新下载、商品海报分享功能将无法正常使用。
        </li>
        <li>
          （3）摄像头，用于身份证识别、银行卡识别、扫码、图片上传，我司不留存您应用手机终端相关功能的信息，拒绝授权后，上述功能将无法使用。
        </li>
        <li>（4）相册，用于扫码、上传图片服务，我司获得的图片信息，加密后存储于数据库中。拒绝授权后，上述功能将无法使用。</li>
        <li>
          （5）地理位置，获取您所在地理位置，主要用于山东一卡通APP交易风控、获取周边优惠信息，拒绝授权后，上述功能可能无法正常使用。
        </li>
        <li>
          （6）网络通讯，用于与服务端进行通讯。拒绝授权后，山东一卡通所有功能无法使用。我司系统后台保存客户交易时所使用设备的网络信息，包括IP、端口信息。
        </li>
        <li>（7）修改声音设置(MODIFY_AUDIO_SETTINGS)，用于语音播报音量调节。拒绝授权后，上述功能可能无法正常使用。</li>
        <li>
          （8）修改WiFi状态(CHANGE_WIFI_STATE)，用于WiFi状态改变时，及时获取网络连接方式，通知用户网络状态切换并上送到后端。拒绝授权后，上述功能可能无法正常使用。
        </li>
        <li>
          （9）修改网络状态(CHANGE_NETWORK_STATE)，用于网络状态改变时，及时获取网络连接方式，通知用户网络状态切换并上送到后端。拒绝授权后，上述功能可能无法正常使用。
        </li>
        <li>
          （10）读取已安装应用列表，我们会收集您终端用户的系统在装应用列表信息，用于调起您终端用户设备中社交平台APP以实现第三方社会化分享，系统后台不保存您已安装应用列表信息。拒绝授权后，上述功能可能无法正常使用。
        </li>
        <li>
          （11）麦克风(RECORD_AUDIO)，在首页进入的搜索页面时可以支持使用语音识别。拒绝授权后，上述功能将无法正常使用。
        </li>
        <li>
          （12）蓝牙(BLUETOOTH)，腾讯位置定位服务需要蓝牙信息用于网络定位。拒绝授权后，无法高精度的iBeacon网络定位，主要场景为室内定位。
        </li>
        <li>
          （13）系统设置(WRITE_SETTINGS)，用于防止腾讯定位SDK接入版本不兼容造成系统崩溃，同时在不同设置下提供更合理的定位能力，排查定位失败问题。拒绝授权后，上述功能将无法使用。
        </li>
        <li>
          （14）获取运行中进程信息，我们会通过系统包管理器来获取所有第三方正在运行的进程信息，以通过对应的包名获得本应用自身的相关版本信息；友盟推送SDK也会通过获取运行中进程信息来适配目标系统和推送方式，系统后台不保存您的运行中进程信息。拒绝授权后，上述功能可能无法使用。
        </li>
        <li>
          （15）剪切板/粘贴板：用于百度移动统计SDK进行设备统计标识读取或写入。拒绝授权后，上述功能可能无法使用。
        </li>
        <li>
          上述功能需要您在您的设备中向我司开启您的设备、存储、相机（摄像头）、相册、地理位置（位置信息）、网络通讯的访问权限，以实现这些功能所涉及的信息的收集和使用。如您是iOS系统，点击路径为您设备中的“设置-隐私”；如您是安卓系统，点击路径为您设备中的“设置-隐私-权限管理”。此外，如果您是鸿蒙系统，在您授权后，我们将获取您选择的相册和地理位置信息。
        </li>
        <li>
          请您注意，您开启这些权限即代表您授权我司可以收集和使用这些信息来实现上述功能，如您取消了这些授权，则我司将不再继续收集和使用您的这些信息，但同时也无法为您提供上述与这些授权所对应的功能。
        </li>
      </ul>
      <div>7、安卓端自启动/关联启动功能：</div>
      <ul>
        <li>
          （1）推送通知消息：为了保证推送服务可靠，我们集成了各厂商推送SDK及友盟推送SDK，我们基于一定策略在不同设备上选择合适的推送SDK实现消息推送功能。为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的广播信息，本应用须使用(自启动)能力，将存在一定频率通过系统发送广播唤醒本应用自启动或关联启动行为，是因实现功能及服务所必要的；当您打开内容类推送消息，在征得您的明确同意后，会跳转打开相关内容。在未征得您同意的情况下，则不会有关联启动；
        </li>
        <li>
          （2）APP下载更新：当您在本APP内部下载文件(比如应用内版本更新提示)，根据下载状态处理HTTP连接并监控连接中的状态变化以及系统重启来确保每一个下载任务顺利完成，特别是当用户切换不同的应用以后下载需要在后台继续进行(可能会有后台进程自启动)，以及当下载任务顺利完成后获取APK文件安装，将导致出现自启现象；
        </li>
        <li>
          （3）如您希望关闭本应用的自启动和关联启动功能，可在手机"设置 &gt; 应用管理（或应用设置）&gt; 自启动管理"中找到"山东一卡通"，关闭对应的自启动和关联启动开关即可。关闭后，您可能无法及时接收到推送通知消息，但不影响应用的其他功能正常使用。
        </li>
      </ul>
    <div>8、无需同意即可收集使用的情形</div>
    <p>根据相关法律法规及国家标准，在以下情形中，我们会依法收集并使用您的个人信息无需征得您的同意：</p>
      <ul>
        <li>（1）与国家安全、国防安全直接相关的；</li>
        <li>（2）与公共安全、公共卫生、重大公共利益直接相关的；</li>
        <li>（3）与刑事侦查、起诉、审判和判决执行等直接相关的；</li>
        <li>（4）出于维护您或他人的生命、财产等重大合法权益但又很难得到您本人同意的；</li>
        <li>（5）所收集的个人信息是您自行向社会公众公开的；</li>
        <li>（6）从合法公开披露的信息中收集个人信息，例如：合法的新闻报道、政府信息公开等渠道；</li>
        <li>（7）根据您的要求签订和履行合同所必需的；</li>
        <li>（8）用于维护所提供的服务的安全稳定运行所必需的，例如：发现、处置产品或服务的故障；</li>
        <li>（9）法律法规规定的其他情形。</li>
      </ul>
    <div>9、第三方SDK服务商</div>
    <p>
      当您使用山东一卡通APP的功能或服务时，在某些特定使用场景下，我司可能会使用具有相应业务资质及能力的第三方服务商提供的软件服务工具包（简称"SDK"）来为您提供服务，由第三方服务商收集您的必要信息，如您拒绝提供相关信息或权限，您将无法使用相关功能服务。更多详情，<b>敬请查阅
      <span class='link' @click='goSdkInfo'>《第三方SDK说明》</span></b>。
    </p>
    <div>10、其他</div>
    <p>
      我们在向您提供其他业务功能时，会另行向您说明信息收集的范围与目的，并征得您的同意后方收集提供相应服务所必要的您的信息。我们会按照本政策以及相应的用户协议约定使用、存储、对外提供及保护您的信息；如您选择不提供前述信息，不会影响您使用支付服务。
    </p>
    <h1>二、我们如何使用Cookie等技术</h1>
    <p>
      为使您获得更轻松的访问体验，您访问我们网站或使用移动端提供的服务时，我们可能会通过小型数据文件识别您的身份，这去重复输入注册信息的步骤，或者帮助判断您的账户安全状态。这些数据文件可能是Cookie、您的浏览器或关联应用程序提供的其他本地存储（以下简称“Cookie”）。请您理解，我们的某些服务只能通过使用Cookie才可得到实现。如您的浏览器或浏览器附加服务允许，您可以修改对Cookie的接受程度或者拒绝使用Cookie。多数浏览器工具条中的“帮助”部分会告诉您怎样防止您的浏览器接受新的Cookie，怎样让您的浏览器在您收到一条新Cookie时通知您或者怎样彻底关闭Cookie。此外，您可以通过改变浏览器附加程序的设置，或通过访问提供商的网页，来关闭或删除浏览器附加程序使用的类似数据（例如：Flash
      Cookie）。但这一举动在某些情况下可能会影响您安全访问我们网站和使用我们提供的服务。</p>
    <p>
      我们网站上还可能包含一些电子图像（以下简称“单像素GIF文件”或“网络Beacon”），使用网络Beacon可以帮助网站计算浏览网页的用户或访么做可帮您省问某些Cookie，我们会通过网络Beacon收集您浏览网页活动的信息，例如：您访问的页面地址、您先前访问的援引页面的位置、您的浏览环境以及显示设定。
    </p>
    <p>
      如您通过我们的网站或APP，使用了由第三方而非山东一卡通提供的服务时，我们无法保证这些第三方会按照我们的要求采取保护措施，为尽力确保您的账号安全，使您获得更安全的访问体验，我们可能会使用专用的网络协议及代理技术（以下简称“专用网络通道”或“网络代理”）。使用专用网络通道，可以帮助您识别到我们已知的高风险站点，减少由此引起的钓鱼、账号泄露等风险，同时更有利于保障您和第三方的共同权益，阻止不法分子篡改您和您希望访问的第三方之间正常服务内容，例如：不安全路由器、非法基站等引起的广告注入、非法内容篡改等。在此过程中，我们也可能会获得和保存关于您计算机的相关信息，例如：IP地址、硬件ID。
    </p>
    <h1>三、我们如何存储和保护个人信息</h1>
    <ul>
      <li>1、我们在中华人民共和国境内收集和产生的个人信息将存储在中华人民共和国境内。我们仅在本政策所述目的所必需期间和法律法规及监管规定的时限内保存您的个人信息，我们仅有国内业务，不涉及境外业务。 在您使用我们的产品与/或服务期间，您的个人信息将在为了实现本政策所述目的之期限内保存，同时将结合法律有强制的留存要求期限的规定确定，如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成日起不少于三年。在超出保存期后，我们会根据适用法律的要求删除您的个人信息，或匿名化处理。例如：手机号码：当您需要使用本APP时，我们需要一直保存您的手机号码，以保证您正常使用该服务；用户头像：当您设置了头像以后，我们会一直保存您的头像，用于登录页面展示使用。我们承诺始终按照法律的规定在合理必要期限内在存储您个人信息。
        超出上述期限或注销用户后，我们将删除您的个人注册信息或对其进行匿名化处理；但依据《电子商务法》《反洗钱法》等法律法规要求，您的交易记录将自交易完成之日起保存不少于三年，保存期满后予以删除或匿名化处理。保存期内，除法律法规另有规定或司法机关依法调取外，我们不会将上述交易记录用于任何其他用途。</li>
      <li>2、为了保障您的信息安全，我们会在现有技术水平下采取合理必要的措施来保护您的信息，采取物理、技术和行政管理安全措施来降低丢失、误用、非授权访问、披露和更改的风险，包括但不限于传输层数据加密、防火墙和加密存储、物理访问控制以及信息访问授权控制。为此我们设置了安全程序保护您的信息不会被未经授权的访问所窃取。</li>
      <li>3、为了保障您的信息安全，我们建立了专门的管理制度、流程和组织以保障信息的安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审计。</li>
      <li>4、我们将在提供服务所需的期限内保存您的个人信息，但法律法规对保存期限另有规定、您同意留存更长的期限、保证服务的安全与质量、实现争议解决目的等所必需的情况下，在前述保存期限到期后，我们将依法、依约或在合理范围内延长保存期限。在超出保存期限后，我们将根据法律规定删除您的个人信息或进行匿名化处理。</li>
      <li>5、我们已制定个人信息安全事件应急预案，定期组织内部相关人员进行应急响应培训和应急演练，使其掌握岗位职责和应急处置策略和规程。在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。</li>
      <li>6、请您务必妥善保管好您的登录账户口令及其他身份要素。您在使用我们服务时，我们会通过您的登录名及其他身份要素来识别您的身份。一旦您泄漏了前述信息，您可能会蒙受损失，并可能产生对您不利的法律后果。如您发现登录名或其他身份要素可能或已经泄露时，请您立即和我们取得联系，以便我们及时采取相应措施以避免或降低相关损失。</li>
      <li>7、在您终止使用我们的服务后，我们会停止对您的信息的收集和使用，法律法规或监管部门另有规定的除外。如我们停止运营，我们将及时停止收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并对所持有的您的个人信息进行删除或匿名化处理。</li>
    </ul>
    <h1>四、我们如何使用个人信息</h1>
    <div>1、个人信息的使用情形</div>
    <p>
      为了遵守国家法律法规及监管要求，以及向您提供服务及提升服务质量，或保障您的账户和资金安全，我们会在以下情形中使用您的信息：
    </p>
    <ul>
      <li>（1）实现本政策中“我们如何收集个人信息”所述目的；</li>
      <li>
        （2）为了保障服务的稳定性与安全性，我们会将您的信息用于<b>身份验证、安全防范、诈骗监测、预防或禁止非法活动、降低风险、存档和备份用途；</b>
      </li>
      <li>（3）根据法律法规或监管要求向相关部门进行报告；</li>
      <li>（4）邀请您参与我们产品或服务有关的客户调研；</li>
      <li>
        （5）为统计、分析您使用我们产品或服务的情况，以辅助我们进行服务体验优化以及产品升级策略，我们会将所有收集的数据经过加密技术处理且无法重新识别特定个人后用于大数据分析。我们可能向您提供营销活动通知，如您不希望接收此类信息，您可根据需要在手机系统设置中的应用管理中关闭应用的消息通知功能。
      </li>
    </ul>
    <div style='font-weight: normal'>
      2、当我们要将信息用于本政策未载明的其他用途时，会按照法律法规及国家标准的要求以确认协议、具体场景下的文案确认动作等形式再次征求您的同意。
    </div>
    <div>
      3、敏感个人信息的特别提示
    </div>
    <ul>
      <li>
        （1）我们根据法律法规的合法性基础收集和使用您的敏感个人信息。我们仅在向您提供APP产品和服务具有特定的目的和充分的必要性下，并采取严格保护措施的情形下，处理您的敏感个人信息。
      </li>
      <li>（2）我们向您收集的敏感个人信息包括生物识别信息、特定身份信息、金融账户信息以及不满十四周岁儿童的个人信息。例如，在业务核身场景下，触发人脸使用的规则为根据该业务功能的必需时，我们会要求您提供<b>人脸信息</b>，以验证您的身份，如果您拒绝同意，您将无法使用该业务功能。
      </li>
      <li>（3）对于敏感个人信息的特殊处理要求，如生物识别信息，在使用服务之前，我们会向您获取单独同意并告知您的敏感个人信息使用规则。在传输和存储敏感个人信息方面，我们会采用加密等安全措施，同时，<b>我们会将您的生物识别信息与您的个人身份信息分开存储，并且原则上不会存储您原始的生物识别信息，仅存储您的生物识别信息的摘要信息。此外，我们不会留存您的个人金融鉴别信息</b>。
      </li>
    </ul>

    <h1>五、我们如何对外提供个人信息</h1>
    <div>1、共享</div>
    <div class='other'>（1）业务共享</div>
    <p>
      我们承诺对您的信息进行保密。除法律法规及监管部门另有规定外，我们仅在以下情形中与第三方共享您的信息，第三方包括我们的关联公司、合作金融机构以及其他合作伙伴。在将信息提供给第三方前，我们将尽商业上合理的努力评估该第三方收集信息的合法性、正当性、必要性。我们会要求第三方处理您的个人信息时遵守法律法规，尽力要求第三方对您的信息采取保护措施。
    </p>
    <ul>
      <li>
        ①为了让您完成交易、实现交易目的，我们需要向您的交易相对方提供交易号与相关支付信息，同时您的交易相对方可在付款过程中或付款成功后查看您的部分注册信息；
      </li>
      <li>②某些产品或服务可能由第三方提供或由我们与第三方共同提供，因此，只有共享您的信息，才能提供您需要的产品或服务。例如：当您授予位置权限后，我们会通过腾讯地图SDK获取到地理位置信息，您可以在购卡时查看营业厅位置和导航路线。</li>
      <li>
        ③如您选择参与我们和第三方联合开展的抽奖、竞赛或类似推广活动，我们可能与其共享活动过程中产生的、为完成活动所必要的信息，以便第三方能及时向您发放奖品或为您提供服务，我们会依据法律法规或国家标准的要求，在活动规则页面或通过其他途径向您明确告知需要向第三方提供何种个人信息；
      </li>
      <li>④事先获得您明确同意的情况下，我们会在法律法规允许且不违背公序良俗的范围内，依据您的授权范围与第三方共享您的信息。
      </li>
      <li>
        <b>关于我们对外提供信息的场景、接收方名称、涉及信息、处理目的等，您可以点击查阅<span class='link' @click='goThirdParty'>《第三方合作服务》</span></b>。
      </li>
    </ul>
    <div class='other'>（2）投诉处理</div>
    <p>
      当您投诉他人或被他人投诉时，为了保护您及他人的合法权益，维护绿色购物环境，我们可能会将您的<b>姓名及有效证件号码、联系方式、投诉相关内容</b>提供给消费者权益保护部门及监管机关，以便及时解决投诉纠纷，但法律法规明确禁止提供的除外。
    </p>
    <div>2、转让</div>
    <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
    <ul>
      <li>（1）事先获得您的明确同意；</li>
      <li>（2）为订立、履行个人作为一方当事人的合同所必需，或者按照依法制定的劳动规章制度和依法签订的集体合同实施人力资源管理所必需；</li>
      <li>（3）为履行法定职责或者法定义务所必需；</li>
      <li>（4）为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</li>
      <li>（5）为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；</li>
      <li>
        （6）在涉及资产转让、收购、兼并、重组或破产清算时，如涉及到个人信息转让，我们会向您告知有关情况，并要求新的持有您个人信息的公司、组织继续受本政策的约束。如变更个人信息使用目的时，我们将要求该公司、组织重新取得您的明确同意。
      </li>
    </ul>
    <div>3、公开披露</div>
    <p>
      除在公布中奖活动名单时会脱敏展示中奖者手机号或登录名外，原则上我们不会将您的信息进行公开披露。如确需公开披露时，我们会向您告知公开披露的目的、披露信息的类型及可能涉及的敏感信息，并征得您的明确同意。在超过保存时限后，我司将对个人信息做匿名化处理。
    </p>
    <div>4、委托处理</div>
    <p>
      为了提升信息处理效率，降低信息处理成本，或提高信息处理准确性，我们可能会委托有能力的关联公司或其他专业机构代表我们来处理用户信息，但我们会通过书面协议、现场审计等方式要求受托公司遵守严格的保密义务及采取有效的保密措施，禁止其将这些信息用于未经您授权的用途。在委托关系解除时，受托公司不再保存个人信息。我们承诺对此负责。
    </p>
    <div>5、无需征得同意的情形</div>
    <p>根据相关法律法规及国家标准，在以下情形中，我们可能会依法共享、转让、公开披露您的个人信息无需征得您的同意：</p>
    <ul>
      <li>（1）与国家安全、国防安全直接相关的；</li>
      <li>（2）与公共安全、公共卫生、重大公共利益直接相关的；</li>
      <li>（3）与刑事侦查、起诉、审判和判决执行等直接相关的；</li>
      <li>（4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</li>
      <li>（5）您自行向社会公众公开的个人信息；</li>
      <li>（6）从合法公开披露的信息中收集的个人信息，例如：合法的新闻报道、政府信息公开等渠道。</li>
    </ul>
    <h1>六、您的权利</h1>
    <p>
      在您使用我们服务期间，为了您可以更加便捷地访问和管理您的个人信息，同时保障您注销账户的权利，我们在产品设计中为您提供了相应的操作设置，您可以参考下面的指引进行操作。</p>
    <div style='font-weight: normal'>
      1、如您发现我们采集、使用您个人信息的行为，违反了法律、行政法规规定或违反了与您的约定，您可通过客服电话联系我们，要求删除该违反行为下采集的您的个人信息。
    </div>
    <div style='font-weight: normal'>2、如您发现我们采集、储存的您的个人信息有错误的，您可以联系我们客服电话要求更正。</div>
    <div style='font-weight: normal'>3、尽管有上述约定，但按照相关法律法规及国家标准，在以下情形中，我们可能无法响应您的请求：</div>
    <ul>
      <li>（1）与国家安全、国防安全直接相关的；</li>
      <li>（2）与公共安全、公共卫生、重大公共利益直接相关的；</li>
      <li>（3）与刑事侦查、起诉、审判和执行判决等直接相关的；</li>
      <li>（4）有充分证据表明您存在主观恶意或滥用权利的；</li>
      <li>（5）响应您的请求将导致其他个人、组织的合法权益受到严重损害的；</li>
      <li>（6）涉及商业秘密的。</li>
    </ul>
    <h1>七、您如何管理您的个人信息</h1>
      <div style='font-weight: normal'>按照中国相关的法律法规和监管规定，我司保障您对自己的个人信息行使以下权利：</div>
      <div>1、访问、更正及更新您的个人信息</div>
      <ul>
        <li>
          您有权通过我司山东一卡通APP等渠道访问及更正、更新您的个人信息，法律法规、监管政策另有规定的除外。您有责任及时更新您的个人信息。在您修改个人信息之前，我司会验证您的身份。
        </li>
        <li>账户信息：如果您希望访问或编辑您的账户中的个人资料信息，您可以在“我的”页面中执行此类操作。登录账户可以在【我的 → 头像 → 个人信息】查看或更改您的个人信息。</li>
        <li>密码信息：您登录山东一卡通APP后，可以在“我的-设置-密码管理”中，进行登录密码以及支付密码的修改。</li>
        <li>实名认证信息：您登录山东一卡通APP后，可以在“我的-服务管理-实名认证”中，进行实名认证信息的查看或修改。</li>
        <li>银行卡信息：您登录山东一卡通APP后，可以在“我的-服务管理-银行卡”中，进行银行卡信息的查看或修改。</li>
      </ul>
      <div>2、删除您的个人信息</div>
      <ul>
        <li>您在我司的产品与/或服务页面中可以直接清除或删除的信息，包括绑定银行卡、消息记录、缓存记录。</li>
        <li>在以下情形中，您可以向我司提出删除个人信息的请求：</li>
        <li>（1）如果我司处理个人信息的行为违反法律法规；</li>
        <li>（2）如果我司收集、使用您的个人信息，却未征得您的同意；</li>
        <li>（3）如果我司处理个人信息的行为违反了与您的约定；</li>
        <li>（4）如果你不再使用我司的产品或服务，或您注销了山东一卡通APP账号；</li>
        <li>（5）如果我司不再为您提供产品或服务。</li>
        <li>当您从我司的服务中删除信息后，我司可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。</li>
      </ul>
      <div>3、改变您授权同意的范围或撤回您的授权</div>
      <ul>
        <li>您可以联系我们撤回您的授权。您可以通过手机系统设置中的【应用权限管理】功能，关闭授予本APP的权限（如摄像头、位置、相册等）。您也可以通过注销账户的方式，撤回我司继续收集您个人信息的全部授权。</li>
      </ul>
      <div>4、注销用户</div>
      <ul>
        <li>
          如您为我司山东一卡通用户，您可通过山东一卡通APP注销用户。您注销用户的行为是不可逆行为，一旦您注销您的用户，我司将不再通过山东一卡通APP收集您的个人信息，并将删除有关您山东一卡通APP的一切信息，法律法规或监管机构对个人信息存储时间另有规定的除外。
        </li>
        <li>APP注销功能在我的-设置-注销，用户在15个工作日内没有交易、账户内相关财产权益已结清的情况下可自行注销。</li>
      </ul>
<!--      <div>5、获取您的个人信息副本</div>-->
<!--      <ul>-->
<!--        <li>-->
<!--          您有权获取您的个人信息副本。您可以通过“我的→设置→个人信息收集清单→个人信息收集情况”查阅并复制您的个人信息副本，以了解您在山东一卡通APP的个人信息使用情况。-->
<!--        </li>-->
<!--      </ul>-->
      <div>5、个性化推荐设置</div>
      <ul>
        <li>为向您提供更便捷、更符合您个性化需求的信息展示，我们会根据您的浏览点击记录等提取您的偏好特征，并基于特征标签产出间接人群画像，用于向您提供精准化信息展示、优惠展示。</li>
        <li>您可以在本APP内通过以下路径进行开启/关闭个性化推荐设置：【我的 → 设置 → 个性化推荐设置】</li>
      </ul>
      <div>6、响应您的请求</div>
      <ul>
        <li>
          如果您无法通过上述方式访问、更正或删除您的用户信息，或您需要访问、更正或删除您在使用我司服务或功能时所产生的其他用户信息，或您认为我司存在任何违反法律法规或与您关于用户信息的收集或使用的约定，您均可通过本政策中的联系方式与我司取得联系。为了保障安全，我司可能需要您提供书面请求，或以其他方式证明您的身份，我司将在收到您反馈并验证您的身份后的15个工作日内完成处理。对于您合理的请求，我司原则上不收取费用，但对多次重复、超出合理限度的请求，我司将视情况收取一定成本费用。对于非法、违规、无正当理由、可能无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我司可能会予以拒绝。
        </li>
        <li>
          此外，根据相关法律法规、监管要求等规定，以下情形中遇到国家有权机关或者监管机关要求的，或者存在以下约定其他情形的，我司将可能无法响应您的请求：
        </li>
        <li>（1）与国家安全、国防安全相关的；</li>
        <li>（2）与公共安全、公共卫生、重大公共利益相关的；</li>
        <li>（3）与刑事侦查、起诉、审判和判决执行等相关的；</li>
        <li>（4）有充分证据表明您存在主观恶意或滥用权利的；</li>
        <li>（5）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</li>
        <li>（6）涉及我司或其他第三方商业秘密的。</li>
      </ul>
      <div>7、征得授权同意的例外</div>
      <ul>
        <li>（1）与个人信息控制者履行法律法规规定的义务相关的；</li>
        <li>（2）与国家安全、国防安全直接相关的；</li>
        <li>（3）与公共安全、公共卫生、重大公共利益直接相关的；</li>
        <li>（4）与刑事侦查、起诉、审判和判决执行等直接相关的；</li>
        <li>（5）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；</li>
        <li>（6）所涉及的个人信息是个人信息主体自行向社会公众公开的；</li>
        <li>（7）根据个人信息主体要求签订和履行合同所必需的；</li>
        <li>（8）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</li>
        <li>（9）维护所提供产品或服务的安全稳定运行所必需的，如发现、处置产品或服务的故障；</li>
        <li>（10）个人信息控制者为新闻单位，且其开展合法的新闻报道所必需的；</li>
        <li>（11）个人信息控制者为学术研究机构，出于公共利益开展统计或学术研究所必要，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的。</li>
      </ul>
      <div>8、无需事先征得同意的情形</div>
      <p>共享、转让、公开披露个人信息时事先征得授权同意的例外以下情形中，个人信息控制者共享、转让、公开披露个人信息不必事先征得个人信息主体的授权同意：</p>
      <ul>
        <li>（1）与个人信息控制者履行法律法规规定的义务相关的；</li>
        <li>（2）与国家安全、国防安全直接相关的；</li>
        <li>（3）与公共安全、公共卫生、重大公共利益直接相关的；</li>
        <li>（4）与刑事侦查、起诉、审判和判决执行等直接相关的；</li>
        <li>（5）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；</li>
        <li>（6）个人信息主体自行向社会公众公开的个人信息；</li>
        <li>（7）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</li>
      </ul>
      <div>9、以下情形可不响应个人信息主体提出的请求，包括：</div>
      <ul>
        <li>（1）与个人信息控制者履行法律法规规定的义务相关的；</li>
        <li>（2）与国家安全、国防安全直接相关的；</li>
        <li>（3）与公共安全、公共卫生、重大公共利益直接相关的；</li>
        <li>（4）与刑事侦查、起诉、审判和执行判决等直接相关的；</li>
        <li>（5）个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的；</li>
        <li>（6）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；</li>
        <li>（7）响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的；</li>
        <li>（8）涉及商业秘密的。</li>
      </ul>
    <h1>八、对第三方责任的声明</h1>
    <ul>
      <li>请您注意，您的交易相对方、您访问的第三方网站经营者、通过我们接入的第三方服务和由我们处接收您的个人信息的第三方可能有自己的隐私保护政策；当您查看第三方创建的网页或使用第三方开发的应用程序时，这些第三方可能会放置他们自己的Cookie或像素标签，这些Cookie或像素标签不受我们的控制，且它们的使用不受本政策的约束。我们会尽商业上和技术上的最大努力去要求和监督这些主体对您的个人信息采取保护措施，如本平台或者您发现这些主体无法保障您的个人信息安全，或存在隐私保障漏洞，我们将在发现时间点12小时内，获得关于他们的隐私权政策不合规的详细情况，并要求这些主体进行整改，要求其72小时内达到本平台指定的用户个人信息保护标准。本平台对接入的第三方合作服务具有全面的监督义务，并对由本平台引起的个人信息保护风险问题具有处理义务，且保证不免除责任。
      </li>
      <li>
        <b>具体第三方服务类型与处理的信息类型可点击查阅：<span class='link' @click='goThirdParty'>《第三方合作服务》</span></b>。
      </li>
    </ul>
    <h1>九、未成年人隐私权特别约定</h1>
    <ul>
      <li>1、我们期望父母或监护人指导未成年人使用我们的服务。我们将根据国家相关法律法规的规定保护未成年人的个人信息的保密性及安全性。</li>
      <li>2、如果您是已满14周岁，未满18周岁的未成年人，建议在您的父母或其他监护人指导下共同阅知本政策内容，并经其同意的前提下使用我们的服务或向我们提供您的信息。对于经父母或监护人同意而收集您的信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护您的权益所必要的情况下使用或公开披露此信息。如您的监护人不同意您按照本政策使用我们的服务或向我们提供信息，请您立即终止使用我们的服务并及时通知我们，以便我们采取相应的措施。</li>
      <li>3、如您为14周岁以下的儿童，请在征得您父母或监护人同意的前提下使用山东一卡通APP内（包含我们和第三方）提供的服务或向我们和第三方提供您的信息。对于经父母或监护人同意而使用您的信息的情况，我们除遵守本隐私政策关于用户个人信息的约定外，还会秉持正当必要、知情同意、目的明确、安全保障、依法利用的原则，严格遵循《儿童个人信息网络保护规定》等法律法规的要求进行存储、使用、披露，且不会超过实现收集、使用目的所必须的期限，到期后我们会对儿童个人信息进行删除或匿名化处理。如您的监护人不同意您按照本政策使用我们的服务或向我们提供信息，请您立即终止使用我们的服务并及时通知我们，以便我们采取相应的措施。</li>
      <li>4、如您为未成年人的父母或监护人，当您对您所监护的未成年人的个人信息处理存在疑问时，请通过上文中的联系方式联系我们。</li>
    </ul>
    <h1>十、本政策的适用及更新</h1>
      <ul>
        <li>1、易通金服支付有限公司山东一卡通APP的所有服务均适用本政策。</li>
        <li>2、发生下列重大变化情形时，我们会适时对本政策进行更新：</li>
        <li>（1）我们的基本情况发生变化，例如：兼并、收购、重组引起的所有者变更；</li>
        <li>（2）收集、存储、使用个人信息的范围、目的、规则发生变化；</li>
        <li>（3）对外提供个人信息的对象、范围、目的发生变化；</li>
        <li>（4）您访问和管理个人信息的方式发生变化；</li>
        <li>（5）数据安全能力、信息安全风险发生变化；</li>
        <li>（6）用户询问、投诉的渠道和机制，以及外部纠纷解决机构及联络方式发生变化；</li>
        <li>（7）其他可能对您的个人信息权益产生重大影响的变化。</li>
        <li>3、其他补充说明：</li>
        <li>
          （1）我们可能会适时对本指引进行修订。当指引的条款发生变更时，我们会在你登录及版本更新时以推送通知、弹窗或其他适当形式向你展示变更后的指引，并单独呈现变更的核心内容，再次征求您的授权，如对隐私政策变更有异议，请您拨打本平台客服电话4006186900反馈，平台运营将第一时间与您联系沟通，并听取您的意见，对于理解差异平台运营将进行详细解释，以求达成统一意见，对于合理或者更优建议将予以采纳，并进一步完善更新本政策。
        </li>
        <li>（2）查看本隐私政策，请访问路径【我的】-【设置】-【隐私政策】。</li>
        <li>（3）我们不会向用户定向推送广告、通知等消息。</li>
      </ul>
    <h1>十一、其他事项</h1>
    <p>本政策所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本政策涵义解释的依据。</p>
    <P>注：本《隐私政策》版本更新日期为2026年10月13日，更新内容主要如下：</P>
    <ul>
      <li>1、更新未成年人隐私保护规定。</li>
      <li>2、更新查看及修改个人信息的路径。</li>
<!--      <li>3、更新获取个人信息副本的方式。</li>-->
    </ul>
    <h1>十二、与我们联系</h1>
      <p>
        您可以在山东一卡通APP通过“我的→设置→隐私政策”中查看本政策。如果您对本隐私政策或您个人信息的相关事宜有任何问题、投诉、建议、未成年个人信息相关问题时，请通过联系客服与我们联系：400-618-6900。同时，我们还设立了个人信息保护负责人专用邮箱ytsdykt01@ecton.com.cn。我们将尽快审核所涉问题，并在验证你的用户身份后的十五天内完成处理。</p>
      <p>
        如果您对我们的答复不满意，特别是如果您认为我们的个人信息处理行为损害了您的合法权益，可先友好协商，再次沟通，您还可以向国家互联网信息办公室、国家市场监督管理总局等有关政府部门或者行业协会进行投诉或举报，您还可以通过向我司所在管辖区的法院提起诉讼来寻求解决。</p>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  data() {
    return {}
  },
  created() {
  },
  methods: {
    goSdkInfo() {
      this.$router.push('/sdkInfo')
    },
    goThirdParty() {
      this.$router.push('/thirdParty')
    }
  }
}

</script>

<style scoped lang='scss'>
.wrapper {
  padding: .16rem .14rem .3rem;
  text-align: left;
  background-color: white;
  line-height: 1.75;
  color: #333;
}

.main-title {
  text-align: center;
  border-left: none;
  padding-left: 0;
  font-size: .18rem;
}

h1 {
  margin: .22rem 0 .1rem;
  font-size: .17rem;
  color: #1a1a1a;
  font-weight: bold;
  padding-left: .08rem;
  border-left: .03rem solid #1e7dff;
  line-height: 1.4;
}

dl {
  margin-bottom: .2rem;
  font-size: .14rem;
  color: #333;
}

dl dt {
  font-size: .15rem;
  color: #1a1a1a;
  font-weight: 500;
  margin-bottom: .04rem;
}

dl dd {
  font-size: .14rem;
  color: #555;
  margin-bottom: .02rem;
}

p {
  margin-bottom: .1rem;
  font-size: .14rem;
  color: #333;
  text-indent: .28rem;
  word-break: break-all;
}

ul li {
  font-size: .14rem;
  color: #333;
  text-indent: .28rem;
  margin-bottom: .06rem;
}

.wrapper > div {
  font-size: .15rem;
  color: #1a1a1a;
  font-weight: 500;
  margin: .1rem 0 .04rem;
}

.wrapper > .other {
  font-size: .14rem;
  color: #1a1a1a;
  font-weight: normal;
}

span {
  display: block;
  font-size: .17rem;
  color: #1a1a1a;
}

b {
  font-weight: bold;
  color: #1a1a1a;
}

footer {
  margin: .4rem 0;
}

.link {
  color: #1e7dff;
  font-size: .14rem;
  display: inline;
}

</style>
